/**
 * Query Key factory for all billing queries.
 *
 * @module Billing
 */

export const billingQKeys = {
  all: () => ["billing"] as const,

  invoices: () => [...billingQKeys.all(), "invoice"] as const,

  invoice: (billId: string) => [...billingQKeys.invoices(), billId] as const,

  consultations: () => [...billingQKeys.all(), "consultation"] as const,

  consultation: (consultationId: string) =>
    [...billingQKeys.consultations(), consultationId] as const,
};
